import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { NewUiButton } from "@ankaadia/ankaadia-shared-frontend";
import { UserFeedbackCreateInput } from "@ankaadia/graphql";
import { Card } from "primeng/card";
import { FloatLabel } from "primeng/floatlabel";
import { Rating } from "primeng/rating";
import { Textarea } from "primeng/textarea";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";

@Component({
  selector: "new-ui-user-feedback-edit-dialog",
  templateUrl: "./new-ui-user-feedback-edit-dialog.component.html",
  imports: [TranslateDirective, Textarea, FloatLabel, ReactiveFormsModule, Card, Rating, NewUiButton],
})
export class NewUiUserFeedbackEditDialogComponent implements OnInit {
  @Input()
  disabled: boolean;

  @Output()
  readonly saved = new EventEmitter<UserFeedbackCreateInput>();

  @Output()
  readonly closed = new EventEmitter<void>();

  form: FormGroup;

  constructor(private readonly formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      overallRating: [null],
      usabilityRating: [null],
      functionalityRating: [null],
      performanceRating: [null],
      comment: [""],
    });
  }
}
